export default function pluralizeFilter(sdk) {
  'ngInject';

  return sdk('utils').pluralize;
}
